export const PREFIX = 'temp';

export function generateTempCommentId() {
  return `${PREFIX}-${Date.now()}`;
}

export function isTempCommentId(id: string) {
  return id.startsWith(PREFIX);
}
